export default "__VITE_ASSET__h4DwbB4P__"